import React from 'react'
import { func } from 'prop-types'
import { CENTRAL_AJUDA, TERMOS_DO_CLUBE } from '../../data/links'
import {
  FooterRoot,
  Container,
  FooterLeft,
  FooterLinks,
  FooterLink,
  LogoutButton
} from './styles'

export default function Footer( { onLogout } ) {
  return (
    <FooterRoot>
      <Container>
        <FooterLeft>Bookster Pelo Mundo · com a TAG · © 2026</FooterLeft>
        <FooterLinks>
          <FooterLink
            href={ TERMOS_DO_CLUBE || '#' }
            onClick={ ( event ) => {
              if ( !TERMOS_DO_CLUBE ) {
                event.preventDefault()
              }
            } }
            rel="noopener noreferrer"
            target={ TERMOS_DO_CLUBE ? '_blank' : null }
          >
            Termos do clube
          </FooterLink>
          <FooterLink
            href={ CENTRAL_AJUDA }
            rel="noopener noreferrer"
            target="_blank"
          >
            Central de ajuda
          </FooterLink>
          <LogoutButton
            onClick={ onLogout }
            type="button"
          >
            Sair
          </LogoutButton>
        </FooterLinks>
      </Container>
    </FooterRoot>
  )
}

Footer.propTypes = {
  'onLogout': func.isRequired
}
